import React, { FC } from 'react';

import { SmartLink } from '../SmartLink/SmartLink';

import './ArticleInsights.scss';
import { KiteIcon } from '@kite/react-kite';

export interface IArticleInsight {
    id?: string;
    eyebrow?: string;
    title?: string;
    description?: string;
    cta: {
        title: string;
        uri: string;
    };
}
export const ArticlesAndInsights: FC<{ article: IArticleInsight }> = ({
    article,
}) => {
    return (
        <li className="articles-insights">
            {article.eyebrow && (
                <p className="articles-insights__eyebrow">
                    {article.eyebrow.toUpperCase()}
                </p>
            )}
            <h4 className="articles-insights__title">{article.title}</h4>
            <p className="typestack-body-2 articles-insights__text">
                {article.description}
            </p>
            <SmartLink
                url={article.cta?.uri}
                classNames={[`articles-insights__cta`]}
            >
                {article.cta.title || `Read More`}
                <KiteIcon icon="ki-arrow-right" />
            </SmartLink>
        </li>
    );
};
